import React from "react";
import { Chart } from "primereact/chart";
import ChartDivider from "../../ChartDivider";
import ChartSkeleton from "../../../Skeletons/ChartSkeleton";
import { getUsesPerDayChartOptions } from "../../../../utils/chartOptions/dashboard/frequency";

const UsesPerDay = React.memo(function UsesPerDay(props) {
  const options = getUsesPerDayChartOptions(props?.usePerDayGraph);
  return (
    <>
      <div className="mt-4" style={{ maxWidth: "100%" }}>
        <div className="mb-4">
          <h5 className="fw-bold mb-2 text-start">Average Daily Frequency</h5>
          {/* <h6 className="fw-bold mb-2 text-start">Base: Products</h6> */}
          <p
            className="mb-0 text-start fw-bold fs-12 pb-3"
            style={{ color: "#6c757d" }}
          >
            Average count of product uses per day
          </p>
          <div className="col-12">
            {!props?.loading ? (
              <Chart
                redraw={(props?.isFilterHide || props?.showSidebar).toString()}
                type="bar"
                data={props?.usePerDayGraph}
                options={options}
              />
            ) : (
              <ChartSkeleton />
            )}
          </div>
          <ChartDivider />
        </div>
      </div>
    </>
  );
});

export default UsesPerDay;
